import React, { useState, useEffect } from "react";
import { Form, Checkbox } from "antd";
import ReCAPTCHA from "react-google-recaptcha";

import InputComponent from "../../components/InputComponent";
import ButtonComponent from "../../components/ButtonComponent";
import ErrorModal from "../../components/ErrorModal";

import useTranslation from "../../hooks/useTranslation";
import TEXT from "../../config/text";
import REQUESTS from "../../api/requests";
import style from "./style/style.module.scss";

export default function AddPlaylistByXtream({
  getPlaylists,
  deviceMac,
  onCancel,
  form
}) {
  const translation = useTranslation();
  const [loading, setLoading] = useState(false);
  const [isProtected, setIsProtected] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);

  // const [form] = Form.useForm();

  const onFinish = (values) => {
    setErrorMessage(null);
    const { name, username, host, password, pin, confirm_pin,epg_url } = values;
    setLoading(true);

    const formData = new FormData();
    formData.append("name", name);
    formData.append("mac", deviceMac);

    const url = `${host}/get.php?username=${username}&password=${password}&type=m3u_plus&output=ts`;

    if (url) {
      formData.append("url",url.split(" ").join(""));
    }

    formData.append("is_protected", isProtected);

    if (isProtected) {
      formData.append("pin", pin);
      formData.append("confirm_pin", confirm_pin);
    }

    if (epg_url) {
      formData.append("epg_url",epg_url.split(" ").join(""));
    }

    function callback() {
      setLoading(false);
      getPlaylists();
      onCancel();
      form.resetFields();
    }

    function errorCallback(error) {
      setErrorMessage(error.message);

      setLoading(false);
    }

    REQUESTS.UPLOAD_PLAYLIST(formData, callback, errorCallback);
  };

  const handleText = (text) => {
    if (translation?.pages?.login?.[text]) {
      return translation?.pages?.playlist?.[text];
    }
    return TEXT?.pages?.playlist?.[text];
  };

  useEffect(() => {
    form.resetFields();
    setIsProtected(false);
  }, []);

  return (
    <div>
      <Form
        autoComplete="off"
        name="upload-playlist-by-xtreame"
        form={form}
        onFinish={onFinish}
        className={style["add-modal-form"]}
      >
        <div style={{ width: "100%" }}>
          <Form.Item
            name="name"
            rules={[
              {
                required: true,
                message: handleText("playlist_name_message"),
              },
            ]}
          >
            <InputComponent placeholder={handleText("playlist_name")} />
          </Form.Item>

          <Form.Item
            name="host"
            rules={[
              {
                required: true,
                message: handleText("host_message"),
              },
            ]}
          >
            <InputComponent placeholder={handleText("host")} />
          </Form.Item>

          <Form.Item
            name="username"
            rules={[
              {
                required: true,
                message: handleText("username_message"),
              },
            ]}
          >
            <InputComponent placeholder={handleText("username")} />
          </Form.Item>

          <Form.Item
            name="password"
            rules={[
              {
                autoComplete: "off",
                required: true,
                message: handleText("password_message"),
              },
            ]}
          >
            <InputComponent
              type="password"
              placeholder={handleText("password")}
            />
          </Form.Item>
          <Form.Item
            name="epg_url"
            rules={[
              {
                validator: (rule, value, callback) => {
                  if (value && !/^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/i.test(value)) {
                    callback('Please enter a valid URL');
                  } else {
                    callback();
                  }
                }
              },
            ]}
          >
            <InputComponent placeholder={handleText("playlist_epg_url")} />
          </Form.Item>

          <Checkbox
            checked={isProtected}
            onChange={(e) => setIsProtected(e.target.checked)}
            className={style["protected-playlist-checkbox"]}
          >
            {handleText("protect_playlist")}
          </Checkbox>
          <div>
            <Form.Item
              name="pin"
              rules={[
                {
                  required: isProtected ? true : false,
                  message: "Please input your password!",
                },
              ]}
              hasFeedback
            >
              <InputComponent
                type="password"
                placeholder={handleText("set_pin")}
                disabled={!isProtected}
              />
            </Form.Item>

            <Form.Item
              name="confirm_pin"
              dependencies={["pin"]}
              hasFeedback
              rules={[
                {
                  required: isProtected ? true : false,
                  message: "Please confirm your password!",
                },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue("pin") === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject(
                      new Error(
                        "The two passwords that you entered do not match!"
                      )
                    );
                  },
                }),
              ]}
            >
              <InputComponent
                type="password"
                placeholder={handleText("confirm_pin")}
                disabled={!isProtected}
              />
            </Form.Item>
          </div>
          
          <div style={{ marginTop: "40px", textAlign: "center" }}>
            <ButtonComponent
              onClick={() => form.submit()}
              title={handleText("url_button_title")}
              loading={loading}
            />
          </div>
        </div>
      </Form>
      <ErrorModal
        message={errorMessage}
        visible={errorMessage ? true : false}
        onClose={() => setErrorMessage(null)}
      />
    </div>
  );
}
